import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full" }
const _hoisted_4 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "text-sm text-clay-800" }
const _hoisted_7 = {
  key: 0,
  class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "mt-5 sm:grid sm:grid-flow-row-dense"
}

import {onMounted, ref, Ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {CheckIcon} from '@heroicons/vue/20/solid';
import {client} from "@/shared";
import {GetMembershipSummary, GetMembershipSummaryResponse, ReactivateProMembership} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReactivateMembership',
  setup(__props) {

// @ts-ignore
let processing = ref(false);
let reactivated = ref(false);
let isOpen = ref(false);

let membershipSummary = ref({});


const openConfirmation = async () => {
    isOpen.value = true;
}

const closeConfirmation = async () => {
    isOpen.value = false;
}

onMounted(async () => {
    await client.get<GetMembershipSummaryResponse>(new GetMembershipSummary())
        .then(response => {
            membershipSummary.value = response;
        });
});

const reactivate = async () => {
    processing.value = true;
    await client.post<GetMembershipSummaryResponse>(new ReactivateProMembership())
        .then(response => {
            processing.value = false;
            reactivated.value = true;
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-white bg-electric-600 border border-transparent rounded-md shadow-sm hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:col-start-2 sm:text-sm",
      type: "button",
      onClick: _withModifiers(openConfirmation, ["prevent"])
    }, " Let my subscription auto renew "),
    _createVNode(_unref(TransitionRoot), {
      show: _unref(isOpen),
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: closeConfirmation
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(CheckIcon), {
                              "aria-hidden": "true",
                              class: "w-6 h-6 text-green-600"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg font-medium leading-6 text-gray-900"
                            }, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode("Keep My Subscription ")
                              ])),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("p", _hoisted_6, "Your subscription will automatically renew on " + _toDisplayString(_unref(membershipSummary).subscription.currentPeriodEndFormatted) + ".", 1)
                            ])
                          ])
                        ]),
                        (!_unref(reactivated))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("button", {
                                disabled: _unref(processing),
                                class: "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-electric-600 border border-transparent rounded-md shadow-sm hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:col-start-2 sm:text-sm",
                                type: "button",
                                onClick: reactivate
                              }, "I Agree ", 8, _hoisted_8),
                              _createElementVNode("button", {
                                ref: "cancelButtonRef",
                                class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                                type: "button",
                                onClick: closeConfirmation
                              }, "Cancel ", 512)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("button", {
                                ref: "cancelButtonRef",
                                class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                                type: "button",
                                onClick: closeConfirmation
                              }, "Ok ", 512)
                            ]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})